import {Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {NgxSpinnerService} from 'ngx-spinner';
import {ToastrService} from 'ngx-toastr';
import {finalize} from 'rxjs';
import {ModuloPermissoesService} from 'src/app/api/module/erp/services/area-logada/modulo-permissoes/modulo-permissoes.service';
import {Modulo} from 'src/app/api/module/erp/shared/enumerable/modulos';
import {PropostaExternaEnum} from 'src/app/api/module/erp/shared/enumerable/poposta-externa.enum';
import {SubModuloNome} from 'src/app/api/module/erp/shared/enumerable/submodulos';
import {ErrorLoggingService} from 'src/app/api/module/erp/shared/services/error-logs/error-logging.service';
import {DeclinioPropostaService} from 'src/app/api/module/externo/services/proposta/declinio.proposta.service';

@Component({
  selector: 'app-declinio-proposta',
  templateUrl: './declinio-proposta.component.html',
  styleUrls: ['./declinio-proposta.component.scss'],
})
export class DeclinioPropostaComponent implements OnInit {
  @Input() stepAtual!: number;
  @Output() propostaDeclinada = new EventEmitter<any>();
  modalRef!: BsModalRef;
  motivoDeclinio: string = '';
  propostaEnum = PropostaExternaEnum;

  constructor(
    private modalService: BsModalService,
    private _activeRoute: ActivatedRoute,
    private _declinioPropostaService: DeclinioPropostaService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private _errorLoggingService: ErrorLoggingService,
    private moduloPermissoesService: ModuloPermissoesService,
  ) {}

  ngOnInit(): void {}

  abrilModalAditivo(templateModalModalAditivo: TemplateRef<any>) {
    this.motivoDeclinio = '';
    this.modalRef = this.modalService.show(templateModalModalAditivo, {
      class: 'modal-lg',
    });
  }

  declinarProposta() {
    this.iniciarSpinner();
    const propostaId = this._activeRoute.snapshot.paramMap.get('idProposta') || '';

    this._declinioPropostaService
      .decliniarProposta(propostaId, this.motivoDeclinio)
      .pipe(
        finalize(() => {
          this.pararSpinner();
        }),
      )
      .subscribe({
        next: data => {
          this.stepAtual = data && data;
          this.toastr.toastrConfig.preventDuplicates = true;
          this.toastr.success('Proposta declinada com sucesso.');
          this.fecharModal();
          this.propostaDeclinada.emit(this.stepAtual);
        },
        error: err => {
          this.toastr.toastrConfig.preventDuplicates = true;
          this.toastr.error('Não foi possivel declinar a proposta.');
          this._errorLoggingService.logError('Erro ao declinar a proposta', err, {
            contexto: 'Falha para declinar a proposta na área de gerenciamento de proposta.',
            dadosEnviados: {
              propostaId: propostaId,
              motivoDeclinio: this.motivoDeclinio,
            },
          });
        },
      });
  }

  fecharModal() {
    this.modalService.hide();
    this.motivoDeclinio = '';
  }

  iniciarSpinner() {
    this.spinner.show();
  }

  pararSpinner(ms?: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this.spinner.hide();
        resolve(true);
      }, ms);
    });
  }

  podeDeclinar(): boolean {
    const temPermissaoDeclinar = this.moduloPermissoesService.permissaoInativar(
      Modulo.CADASTROS,
      SubModuloNome.PROPOSTA_CADASTRO,
    );

    if (
      !temPermissaoDeclinar ||
      this.stepAtual == this.propostaEnum.PROPOSTA_DECLINADA 
    ) {
      return false;
    }
    return true;
  }
}
